function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 363",
  fill: "#00a3e0"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 125",
  d: "M26.74 37.203H8.139a1.163 1.163 0 01-1.163-1.163V17.439a1.163 1.163 0 011.163-1.163h18.6a1.163 1.163 0 011.163 1.163v18.6a1.163 1.163 0 01-1.162 1.164zM9.301 34.876h16.275V18.601H9.301z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 126",
  d: "M33.715 30.228h-3.487v-2.327h2.325V12.789a1.163 1.163 0 00-1.163-1.163H3.488a1.163 1.163 0 00-1.163 1.163v15.112H4.65v2.325H1.163A1.163 1.163 0 010 29.065V12.789a3.489 3.489 0 013.488-3.488h27.9a3.489 3.489 0 013.488 3.488v16.276a1.163 1.163 0 01-1.161 1.163z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 127",
  d: "M27.903 11.626h-2.327v-9.3H9.301v9.3H6.976V1.163A1.163 1.163 0 018.139 0h18.6a1.163 1.163 0 011.163 1.163z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 147",
  d: "M12 21.203h11v2H12z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 148",
  d: "M12 25.203h11v3H12z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 149",
  d: "M12 30.203h9v2h-9z"
}));

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.878 37.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.b190a9e4.svg";
export { ForwardRef as ReactComponent };